import { Fragment } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserGuard } from '../guards/UserGuard';


export type RouteWrapperProps = {
    guard?: () => boolean;
    redirectPath?: string;
    element: JSX.Element;
};

export default function RouteWrapper({ guard, redirectPath, element }: RouteWrapperProps) {
    const location = useLocation();
    const redirectNotExistingRoutes = UserGuard() ? '/home' : '/auth'
    const redirect = redirectPath || redirectNotExistingRoutes || '/auth';
    if ((guard && guard()) || location.pathname === redirect || guard === undefined) {
        return <Fragment>{element}</Fragment>;
    } else {
        return (
            <Fragment>
                <Navigate to={{ pathname: redirect }} />
            </Fragment>
        );
    }
}
